import { createFileRoute } from '@tanstack/react-router'
import { PresentationView } from '@/features/tracker/PresentationView'

function Present() {
  const { companyId, asUser, status, priority, q, waitingOn } = Route.useSearch()
  return <PresentationView companyId={companyId} asUser={asUser} status={status} priority={priority} q={q} waitingOn={waitingOn} />
}

interface PresentSearch {
  companyId?: string
  asUser?: string
  // Carried from the tracker list's active filters (design doc "Presenting
  // follows the list's filters", 2026-08-24) — applied server-side by
  // getTrackerPresentation, not filtered here, so the deck stays a single
  // source of truth.
  status?: string
  priority?: string
  q?: string
  waitingOn?: string
}

function asOptionalString(raw: unknown): string | undefined {
  return typeof raw === 'string' && raw ? raw : undefined
}

export const Route = createFileRoute('/tracker/present')({
  // companyId: staff arrive here from a specific ticket's row on the tracker
  // list, which already knows that ticket's companyId (see TrackerListView's
  // Present button) — an admin request without it 400s server-side
  // (getTrackerPresentation requires companyId for an unlensed admin).
  // Not required at all while lensed: the server resolves the lensed user's
  // own company and ignores companyId, same as every other tracker route.
  validateSearch: (raw: Record<string, unknown>): PresentSearch => ({
    companyId: asOptionalString(raw.companyId),
    asUser: asOptionalString(raw.asUser),
    status: asOptionalString(raw.status),
    priority: asOptionalString(raw.priority),
    q: asOptionalString(raw.q),
    waitingOn: asOptionalString(raw.waitingOn),
  }),
  component: Present,
})
